// CTV-445: shared y-axis helpers for the trend/delivery charts (on-page + PDF),
// so the report and export use the same dynamic floored scale + compact labels.

// "Nice" axis with a non-zero floor: rounds [dataMin, dataMax] out to clean step
// boundaries so values clustered high (e.g. all > 100K) use the full plot height
// instead of hugging the top.
export function niceAxisRange(dataMin: number, dataMax: number, targetCount = 4): { min: number; max: number; ticks: number[] } {
  if (!(dataMax > dataMin)) {
    // Flat data — show a small band centered on the value.
    const pad = Math.max(1, Math.abs(dataMax) * 0.1);
    const lo = Math.max(0, dataMax - pad);
    return { min: lo, max: dataMax + pad, ticks: [dataMax + pad, dataMax, lo] };
  }
  const rawStep = (dataMax - dataMin) / targetCount;
  const base = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const f = rawStep / base;
  const niceF = f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10;
  const step = niceF * base;
  const min = Math.max(0, Math.floor(dataMin / step) * step);
  const max = Math.ceil(dataMax / step) * step;
  const ticks: number[] = [];
  for (let v = max; v >= min - 0.0001; v -= step) ticks.push(Math.round(v));
  return { min, max, ticks };
}

// Compact y-axis label: 12000 → "12K", 2500 → "2.5K", 1_200_000 → "1.2M".
export function fmtAxis(v: number): string {
  if (v >= 1_000_000) return `${+(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000) return `${+(v / 1_000).toFixed(1)}K`;
  return String(v);
}
